<template>
  <div class="d-flex align-start">
    <v-checkbox
      v-model="isAgree"
      class="mt-0 pt-0 mr-2"
      color="primary"
      hide-details
    />
    <div
      v-if="isLpu"
      class="text-body-2 text--text"
    >
      {{ t('Подаю', options) }}
      <a
        target="_blank"
        rel="noopener noreferrer"
        class="text-decoration-none primary--text d-inline"
        :href="registrationAgreementLink"
      >{{ t('заявление', options) }}</a>
      {{ t('на подключение юрлица и обработку персональных данных', options) }}
    </div>
    <div
      v-if="isDoctor"
      class="text-body-2 text--text"
    >
      {{ t('Даю', options) }}
      <a
        target="_blank"
        rel="noopener noreferrer"
        class="text-decoration-none primary--text d-inline"
        :href="registrationAgreementLink"
      >{{ t('согласие', options) }}</a>
      {{ t('на обработку персональных данных', options) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import I18NextVue from 'i18next'

const { t, language } = I18NextVue
const options = { ns: language }

const props = defineProps<{
  value: boolean
  isLpu: boolean
  isDoctor: boolean
  registrationAgreementLink: string
}>()

type Emits = {
  (_event: 'input', _value: boolean): void,
}

const emit = defineEmits<Emits>()

const isAgree = computed({
  get() {
    return props.value
  },
  set(value: boolean) {
    emit('input', value)
  },
})
</script>
